import src from "IMAGE";
export default { src, width: 185, height: 185, blurWidth: 0, blurHeight: 0};
